import { KeycloakAngularModule, KeycloakService } from 'keycloak-angular';
import { APP_INITIALIZER, ApplicationConfig, importProvidersFrom } from '@angular/core';
import { ScrollDispatcher, ScrollingModule } from '@angular/cdk/scrolling';
import { provideRouter } from '@angular/router';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MAT_TOOLTIP_DEFAULT_OPTIONS } from '@angular/material/tooltip';
import {
  MY_MAT_TOOLTIP_DEFAULT_OPTIONS,
  SharedCommonModule
} from './app/common/shared-common.module';
import { ResultModule } from './app/main/result/result.module';
import { CategoryModule } from './app/main/category/category.module';
import { ResizeWindowService } from './app/common/services/resize-window.service';
import { CategoriesService } from './app/common/services/categories.service';
import { FormsCommonModule } from './app/common/forms-common.module';
import { TablesCommonModule } from './app/common/tables-common.module';
import { LayoutModule } from './app/layout/layout.module';
import { ApplicationModule } from './app/main/application/application.module';
import { environment } from './environments/environment';
import { appRoutes } from './app/app-routing.module';
import { InterceptorErrorsService } from './app/common/services/interceptor-errors.service';
import { AuthHeaderInterceptor } from './app/common/services/interceptor.service';
import { provideBarbaraUiLabels } from 'barbara-ui';

function initializeKeycloak(keycloak: KeycloakService) {
  return async () => {
    return await keycloak.init({
      config: {
        url: environment.auth_server,
        realm: environment.keycloak_realm,
        clientId: 'barbara_market_frontend'
      },
      initOptions: {
        onLoad: 'check-sso', // 'login-required' , 'check-sso'
        silentCheckSsoRedirectUri: window.location.origin + '/assets/silent-check-sso.html',
        enableLogging: true,
        pkceMethod: 'S256'
      },
      enableBearerInterceptor: true
    });
  };
}

export const appConfig: ApplicationConfig = {
  providers: [
    ResizeWindowService,
    CategoriesService,
    ScrollDispatcher,
    provideRouter(appRoutes),
    importProvidersFrom(
      HttpClientModule,
      BrowserAnimationsModule,
      KeycloakAngularModule,
      SharedCommonModule,
      FormsCommonModule,
      TablesCommonModule,
      LayoutModule,
      ApplicationModule,
      CategoryModule,
      ResultModule,
      ScrollingModule
    ),
    {
      provide: APP_INITIALIZER,
      useFactory: initializeKeycloak,
      multi: true,
      deps: [KeycloakService]
    },
    /*  {
      provide: HTTP_INTERCEPTORS,
      useClass: KeycloakBearerInterceptor,
      multi: true
    },*/

    {
      provide: HTTP_INTERCEPTORS,
      useClass: InterceptorErrorsService,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthHeaderInterceptor,
      multi: true
    },
    {
      provide: MAT_TOOLTIP_DEFAULT_OPTIONS,
      useValue: MY_MAT_TOOLTIP_DEFAULT_OPTIONS
    },
    provideBarbaraUiLabels({
      isRequired: ' is required',
      isNotValid: ' is not valid',
      errorSize: 'File size cannot exceed ',
      errorType: 'Invalid extension, allowed: ',
      errorTypes: 'Invalid extension, allowed: ',
      search: 'Search'
    })
  ]
};
